import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { MobileTray } from '../mobile-tray';
import AsyncSelect from 'react-select/async';
import { customStyles } from '../../search-module/components/activity/custom-select/custom-styles';
import { CustomMenuList } from '../../search-module/components/activity/custom-select/custom-menu-list';
import { CustomInput } from '../../search-module/components/activity/custom-select/custom-input';

const ActivityInputTray = (props) => {
  const { intl } = props;
  const [visible, setVisible] = useState(false);

  const {
    loadOptions,
    onChange,
    inputChange,
    handleInputFocus,
    defaultOptions,
    handleInputBlur,
    handleContainerFocus,
    isOptionError,
    isFocused,
    inputDisplay,
    displayValue,
    formActive,
    blur
  } = props;

  const label = intl.formatMessage({ id: 'shared_component.mobile_activity_input.label', defaultMessage: 'What are you planning?' });
  const placeholder = intl.formatMessage({ id: 'shared_component.mobile-activity-input.placeholder', defaultMessage: 'Enter your activity' });

  return (
    <div className="activity-input-container">
      <button
        className="activity-input inline-block text-left full-width"
        onClick={(e) => {
          e.preventDefault();
          setVisible(true);
        }}
      >
        {displayValue
          ? <span className="text-gray-900">
            {displayValue}
          </span>
          : <span className="text-gray-600">
            <FormattedMessage
              id="search.activity-input.placeholder"
              defaultMessage="Enter your activity"
            />
          </span>
        }
      </button>
      <MobileTray
        isVisible={visible}
        setIsVisible={(visible) => {
          setVisible(visible);
          if (!visible) {
            blur();
          }
        }}
      >
        <div
          className="activity-tray full-width"
          onFocus={handleContainerFocus}
        >
          <div className="gutter">
            <label
              htmlFor='activity-input'
              className="activity-tray-label h4"
            >
              {label}
            </label>
            <AsyncSelect
              id='activity-input'
              instanceId='activity-input'
              controlShouldRenderValue={false}
              placeholder={placeholder}
              isClearable
              autoFocus={true}
              onFocus={handleInputFocus}
              onBlur={handleInputBlur}
              onChange={(...args) => {
                setVisible(false);
                onChange(...args);
              }}
              onInputChange={inputChange}
              inputValue={inputDisplay}
              defaultOptions={defaultOptions}
              loadOptions={loadOptions}
              styles={customStyles(isFocused, formActive, true)}
              noOptionsMessage={() => null}
              getOptionValue={(suggestion) => suggestion.value}
              components={{
                MenuList: (props) => CustomMenuList(props, isOptionError),
                LoadingIndicator: () => null,
                IndicatorsContainer: () => null,
                Input: CustomInput
              }}
            />
          </div>
        </div>
      </MobileTray>
    </div>
  );
};

ActivityInputTray.propTypes = {
  loadOptions: PropTypes.func,
  onChange: PropTypes.func,
  inputChange: PropTypes.func,
  handleInputFocus: PropTypes.func,
  defaultOptions: PropTypes.array,
  handleInputBlur: PropTypes.func,
  handleContainerFocus: PropTypes.func,
  isOptionError: PropTypes.bool,
  isFocused: PropTypes.bool,
  inputDisplay: PropTypes.string,
  displayValue: PropTypes.string,
  formActive: PropTypes.bool,
  blur: PropTypes.func,
  input: PropTypes.object,
  intl: intlShape
};

exports.ActivityInputTray = injectIntl(ActivityInputTray);
